export const statusCodeErrorMsg = {
  400: 'Bad Request..!',
  401: 'Unauthorized',
  404: 'Requested resource not found..!',
  413: 'Maximum file size 100Mb allowed.',
  500: 'Server error!! Please try after sometime..!',
  502: 'Server under maintenance..!',
  0: 'Sorry ! Something went wrong',
};
